import React, { useState } from "react";
import Footer from "../Footer";
import Header from "../Header";
import contactImg from '../../img/contact-img.png';
import SwiperSection from "../HomePageComponents/SwiperSection";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

const Base_Url = process.env.REACT_APP_BASE_URL;

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phoneNumber: '', message: '' });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    
    const handleChange = (e) => {
        setErrors({ ...errors, [e.target.name]: '' })
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const { name, email, phoneNumber, message } = formData;
        const errors = {};
        if (!name) errors.name = "Name is required";
        if (!email) errors.email = "Email is required";
        if (!phoneNumber) errors.phoneNumber = "Phone number is required";
        if (!message) errors.message = "Enter some message";
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});

        try {
            const response = await fetch(`${Base_Url}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                toast.success('Message sent successfully');
                setFormData({ name: '', email: '', phoneNumber: '', message: '' });
                navigate('/thanks', { state: { show: true, page: 'contact' } });
            } else {
                toast.error('Failed to send message');
            }
        } catch (err) {
            console.error('Error:', err);
            toast.error('Server Error');
        }
    };

    return (
        <>
            <Header />
            <ToastContainer />
            <section className="contact-us-main">
                <div className="container">
                    <div className="banner-main-ct">
                        <div className="contact-banner-content">
                            <h1 className="about-title-banner">Contact Us</h1>
                            <h3 className="page-active-main"><a href="/"><span className="active-page">Home</span></a> / Contact Us</h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className="contact-form-main">
                <div className="container">
                    <div className="contect-master-flx">
                        <div className="contact-form-left">
                            <h2 className="contact-title">Send Us a Message</h2>
                            <form onSubmit={handleSubmit}>
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
                                {errors.name && <p className="error-message">{errors.name}</p>}

                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                                {errors.email && <p className="error-message">{errors.email}</p>}

                                <label htmlFor="phoneNumber">Phone</label>
                                <input type="tel" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                                {errors.phoneNumber && <p className="error-message">{errors.phoneNumber}</p>}

                                <label htmlFor="message">Message</label>
                                <textarea id="message" name="message" rows="4" value={formData.message} onChange={handleChange} required></textarea>
                                {errors.message && <p className="error-message">{errors.message}</p>}

                                <button type="submit">Submit</button>
                            </form>
                        </div>
                        <div className="contact-form-right">
                            <img src={contactImg} alt="Contact Us" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="organisation-section-main">
                <div className="container">
                    <div className="our-org-top">
                        <h2 className="org-title">Our Organisation</h2>
                        <p className="org-p">Sharksucker sea toad candiru rocket danio tilefish stingray deepwater stingray Sacramento splittail, Canthigaster rostrata. Midshipman dartfish Modoc sucker, yellowtail kingfish</p>
                    </div>
                </div>
                <SwiperSection />
            </section>

            <Footer />
        </>
    );
};

export default Contact;
